<template>
    <form-select
        v-if="!loading"
        :value="value"
        :required="required"
        v-model="val"
        :error="error"
        :name="name"
        :label="label || name"
        :labelClasses="labelClasses"
        :inputHolderClasses="inputHolderClasses"
        :options="options"
        :allow-empty="false"
    />
</template>
<script>
    export default {
        name: 'yes-no-select',
        props: {
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
            },
            return: {
                type: String,
                required: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            value: {
                // type: Number,
                required: false,
                default: null,
            },
            error: {
                type: String,
                default: null,
            },
            labelClasses: {
                type: String,
                required: false,
            },
            inputHolderClasses: {
                type: String,
                required: false,
            },
            noLabel: {
                type: String,
                required: false,
            },
            yesLabel: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                loading: true,
                val: null,
                options: [
                    {
                        name: this.uLang('app.yes'),
                        id: 1,
                    },
                    {
                        name: this.uLang('app.no'),
                        id: 0,
                    },
                ],
            };
        },
        created: function () {
            this.val = this.options[1];

            if (this.value != null && Number.isInteger(this.value)) {
                this.val = this.options.find((option) => {
                    return option.id == this.value;
                });
            }
        },
        mounted() {
            this.options[0].name = this.yesLabel || this.uLang('app.yes')
            this.options[1].name = this.noLabel || this.uLang('app.no')
            this.loading = false
        },
        watch: {
            val: function (newVal, oldVal) {
                if (newVal != null) {
                    return this.$emit('input', newVal['id']);
                }
                this.$emit('input', newVal);
            },
        },
    };
</script>
